import { useQuery } from '@tanstack/react-query'
import { getAdminStats } from '@/api/adminService'

export function useAdminStats() {
  return useQuery({
    queryKey: ['admin', 'stats'],
    queryFn: getAdminStats,
    refetchInterval: 30000,
  })
}
